export const FILTER_WARRANTIES_VALUE = '1'
export const FILTER_RETACTS_VALUE = '3'
